// Navigation utilities for simple, consistent navigation across the app

import { useAuth } from '../context/AuthContext';

// Dashboard routes mapping based on user roles
export const getDashboardRouteByRole = (userRole) => {
  const dashboardRoutes = {
    'SuperAdmin': '/admin/dashboard',
    'SystemAdmin': '/system-admin/dashboard', 
    'Hospital': '/hospital/dashboard',
    'Doctor': '/doctor/dashboard',
    'PolicyWriter': '/policy/dashboard',
    'FinancialTeam': '/finance/dashboard',
    'LeadGenerator': '/lead-generator/dashboard'
  };
  
  return dashboardRoutes[userRole] || '/';
};

// Simple back to dashboard navigation
export const useBackToDashboard = () => {
  const { userRole } = useAuth();
  
  const goBackToDashboard = (navigate) => {
    const dashboardRoute = getDashboardRouteByRole(userRole);
    navigate(dashboardRoute, { replace: true });
  };
  
  return goBackToDashboard;
};

// Simple back navigation (one step back)
export const useSimpleBack = () => {
  const goBack = (navigate) => {
    navigate(-1);
  };
  
  return goBack;
};

// Prevent going back to login after successful login
export const preventBackToLogin = (navigate, userRole) => {
  if (userRole) {
    // Replace the login page in history with dashboard
    const dashboardRoute = getDashboardRouteByRole(userRole);
    navigate(dashboardRoute, { replace: true });
  }
};

// Navigation with history replacement to prevent back button issues
export const navigateWithReplace = (navigate, route) => {
  navigate(route, { replace: true });
};

export default {
  getDashboardRouteByRole,
  useBackToDashboard,
  useSimpleBack,
  preventBackToLogin,
  navigateWithReplace
};
